import { Skeleton, Box } from "@mui/material";

const BannerSkeleton = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <Box sx={{ my: 4 }}>
      <Skeleton variant="rectangular" width="100%" height={300} />
    </Box>
  );
};

export default BannerSkeleton;
